import React from 'react';
import { Outlet } from 'react-router-dom';
import { Banner } from './Banner';
import Footer from './Footer';

const MainLayout = () => {
  return (
    <div className="flex flex-column min-h-screen">
      <header>
        <Banner />
      </header>
      <main className="main-content flex-grow-1">
        <div className="p-3 md:p-4">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;